<template>
  <div class="flex items-center justify-center w-full ">
    <div class="relative aspect-[9/16] overflow-hidden rounded-lg max-w-[200px] md:max-w-[400px] w-full shadow-lg cursor-pointer" @click="togglePlayer">
      <video ref="player" class="w-full h-full object-cover" :poster="post.thumbnail" preload="metadata">
        <source :src="post.content">
      </video>
      <div v-if="!playing" class="absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center">
        <PlayIcon class="w-16 h-16 md:w-24 md:h-24 text-white/80"/>
      </div>
      <div class="absolute left-0 right-0 top-2/4 bottom-0 bg-gradient-to-t from-black/70 to-black/0"></div>
      <div class="absolute bottom-6 left-4 flex items-center space-x-2.5">
          <img :src="post.profile" class="w-9 h-9 md:w-12 md:h-12 rounded-full border-2 border-white"/>
          <span class="text-xs md:text-sm text-white font-semibold text-shadow">@{{post.username}}</span>
        </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ContentfulFeaturedPost } from '@/services/contentful/types'
import { PlayIcon } from '@heroicons/vue/20/solid'
import { ref } from 'vue'

const props = defineProps<{
  post: ContentfulFeaturedPost
}>()

const playing = ref(false)
const player = ref(null)

function togglePlayer() {
  if (playing.value) {
    player.value.pause()
    playing.value = false
  } else {
    player.value.play()
    playing.value = true
  }
}
</script>